import React, { useEffect, useContext, useRef, useState } from 'react'
import moment from 'moment'
import container from 'postcss/lib/container'
import useInput from '../../useInput'
import { InputBaseProps } from '../../Input.types'
import WithPopup from '../../withPopup/withPopup'
import useDate from '../useDate'
import Button from '../../../Button/Button'
import YearInput from '../DateInputElements/YearInput'
import MonthInput from '../DateInputElements/MonthInput'
import DayInput from '../DateInputElements/DayInput'

import DateCalendar from '../DateInputElements/DateCalendar'
import DateInput from '../DateInput'

import { DatepickerProps } from './Datepicker.types'
import InputWrapper from '../../InputWrapper/InputWrapper'
import Icon from '../../../Icon/Icon'

export interface DateInputProps extends InputBaseProps {
    delimiter?: string
    format?: string
}

const DatePicker: React.FC<DatepickerProps> = (props) => {
    const { delimiter = '/', format = 'MM/DD/YY', showCalendar = false, depth = 'day', min, max } = props
    const context = useInput(props, 'date')
    const { value, onChange, onFocus, onBlur, isDisabled } = context
    const [showCalendarPopup, setShowCalendarPopup] = useState(false)
    const {
        startDate,
        startDay,
        startMonth,
        startYear,
        setStartDay,
        setStartMonth,
        setStartYear,
        isStartValid,
    } = useDate({
        isRange: false,
        onChange,
        value,
        // format,
        // helpers: [],
        depth,
        min,
        max,
    })
    const [internalDate, setInternalDate] = useState(false)
    const [isDirty, setIsDirty] = useState(false)
    useEffect(() => {
        setIsDirty(true)
    }, [internalDate])
    useEffect(() => {
        setIsDirty(false)
    }, [])
    return (
        <InputWrapper {...context}>
            <WithPopup
                content={() => {
                    return (
                        <div className={'r-datepicker-wrapper'}>
                            {/*<DateCalendar*/}
                            {/*    depth={depth}*/}
                            {/*    start={value}*/}
                            {/*    viewMonth={viewStartMonth}*/}
                            {/*    viewYear={viewStartYear}*/}
                            {/*    setViewMonth={setViewStartMonth}*/}
                            {/*    setViewYear={setViewStartYear}*/}
                            {/*    handleDateSelect={(date) => {*/}
                            {/*        onChange(date)*/}
                            {/*        setShowCalendarPopup(false)*/}
                            {/*    }}*/}
                            {/*/>*/}
                        </div>
                    )
                }}
                show={showCalendarPopup && !isDisabled}
                onShow={onFocus}
                onClose={onBlur}
                width={'auto'}
                maxHeight={null}
            >
                {(popupContext) => {
                    return (
                        <div ref={popupContext.anchor} className={'r-input-base r-datepicker-container'}>
                            {isDirty ? (
                                <Icon
                                    style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}
                                    type={isStartValid ? 'check-circle' : 'exclamation-circle'}
                                    className={isStartValid ? 'r-color-green' : 'r-color-red'}
                                />
                            ) : null}

                            <DateInput
                                depth={depth}
                                format={format}
                                isDisabled={isDisabled}
                                day={startDay}
                                month={startMonth}
                                year={startYear}
                                setDate={(v) => {
                                    setInternalDate(v)
                                }}
                                setDay={setStartDay}
                                setMonth={setStartMonth}
                                setYear={setStartYear}
                            />
                            {showCalendar ? (
                                <Button
                                    style={{ margin: '0 0 0 4px' }}
                                    buttonStyle={{ padding: '1px 5px 3px 5px' }}
                                    size={'sm'}
                                    icon={'calendar-alt'}
                                    onClick={(e) => setShowCalendarPopup(true)}
                                />
                            ) : null}
                        </div>
                    )
                }}
            </WithPopup>
        </InputWrapper>
    )
}

export default DatePicker
